// 葡萄牙语
import constant from '../../constants/lang/pt';
import newLang from '../newLang/pt';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Faça login primeiro',
        404: 'Sem dados',
        500: 'O sistema está ocupado, tente novamente mais tarde',
        504: 'A solicitação expirou',
        ERR_NETWORK: 'Exceção de rede',
        ERR_NETWORK_UPLOAD: 'Falha no upload, tente outra rede',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Luz indicadora',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Registros',
        'feedback-create': 'Feedback',
        'feedback-supplement': 'Feedback adicional',
        'feedback-detail': 'Detalhes de feedback',
        'feedback-result': 'Feedback',
        guide: 'Centro de ajuda',
        'guide-restScreen': 'Configurar instruções',
        'guide-overview': 'Visão geral das funções',
        'guide-account': 'Sobre Account',
        'guide-vehicle': 'Sobre o veículo',
        'guide-meterSetting': 'Como configurar o painel de instrumentos',
        'guide-vehicleSetting': 'Como configurar o veículo',
        'guide-findNavigation': 'Como navegar para encontrar o veículo',
        'guide-vehicleNnavigation': 'Como utilizar a navegação',
        'guide-cyclingRecord': 'Sobre a História do Ride',
        'guide-vehicleExperience': 'Como realizar uma auto-inspecção de um veículo',
        'guide-useSetting': 'Como fazer as configurações gerais do APP',
        'guide-notice': 'Como visualizar e definir a notificação de mensagem',
        'guide-about': 'Sobre o APP',
        help: 'Ajuda e feedback',
        'help-detail': 'Detalhes da pergunta',
        'myCar-unbinding': 'Aplicar a desvinculação',
        'myCar-unbinding-result': 'Aplicar a desvinculação',
      },
    },
    form: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      submit: 'Enviar',
      search: 'Pesquisar',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Protocolo`,
      text1: '1.	Serviços de telemática',
      text2:
        'A CFMOTO Powersports, Inc. (doravante denominada “ CFMOTO ” ) fornece serviços de telemática de veículos ao cliente que comprou o veículo CFMOTO (doravante denominado “Cliente” ). Para estes serviços, a CFMOTO utiliza os dados registados pelo Veículo sobre o Veículo e o seu comportamento de condução no período de tempo relevante. Em detalhes, trata-se dos seguintes dados:',
      text3: 'Dados do comportamento de direção do usuário : incluindo aceleração, desaceleração, velocidade, curvas, último tempo de direção e última milhagem de direção .',
      text4:
        'Dados de status do veículo: refere-se ao status em tempo real do veículo, incluindo modo de condução, combustível residual, economia instantânea de combustível, quilometragem, marcha em tempo real do veículo, velocidade do motor, pressão dos pneus, temperatura dos pneus, dados de tensão de ativação da bateria , temperatura do líquido refrigerante, status do bloqueio eletrônico, versão do software do dispositivo inteligente, intensidade do sinal de dispositivos inteligentes, configuração atual do painel.',
      text5:
        'Dados de alarme do veículo: dados de alarme a serem enviados se determinados dados excederem um valor predefinido, como temperatura do motor, velocidade excessiva, tempo excessivo de condução, alta temperatura do líquido de arrefecimento, movimento anormal do veículo, pressão anormal dos pneus, vibração, despejo, colisão , etc. .',
      text6: 'Informações de falha do veículo: refere-se aos códigos de falha relatados por cada parte interna do veículo.',
      text7: 'Dados de Localização do Veículo: refere-se ao paradeiro geográfico específico do Veículo.',
      text8: '1.1.	Fornecendo _ o Cliente com serviços relacionados ao veículo através do APP CFMOTO RIDE .',
      text9:
        '1.1.1.	Os Consumidores podem gerenciar remotamente os veículos através do aplicativo CFMOTO RIDE (incluindo a visualização da localização do veículo, configuração das informações e funções do veículo, controle remoto do status do veículo, etc.).',
      text10: '1.1.2.	Fornecer planejamento de rotas durante a navegação, incluindo o cálculo da distância entre veículos e navegação a pé com o objetivo de encontrar um veículo .',
      text11: '1.2.	Envio de notificações necessárias ao Cliente com base nas condições do veículo.',
      text12:
        '1.2.1.	A CFMOTO enviará ao Cliente notificações sobre a manutenção do veículo (por exemplo, com base na distância total que o Cliente percorre, a hora em que o Cliente compra o veículo, os requisitos de tempo ou distância percorrida para a manutenção do veículo) .',
      text13:
        '1.2.2.	Com base nos dados do veículo , a CFMOTO enviará ao Cliente notificações de situações anormais; incluindo análise de dados pelo OEM (dependendo do modelo) para fornecer atendimento ao cliente e otimização de acompanhamento do veículo .',
      text14: '1.3.	Apoio na análise da causa do acidente caso o Cliente comunique um acidente grave do Veículo.',
      text15:
        '1.3.1.	Em caso de acidente grave com o Veículo, como por exemplo capotamento ou capotamento do Veículo durante a condução, a CFMOTO apoiará o Cliente, mediante pedido, esclarecendo se o acidente se deve a defeito do Veículo ou outras circunstâncias. O pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
      text16: '1.3.2.	Na medida em que os dados disponíveis o permitam, a CFMOTO avaliará os dados em relação à causa do acidente e fornecerá ao Cliente o correspondente relatório.',
      text17: '1.4.	Assistência ao Cliente na recuperação do Veículo após o seu extravio .',
      text18:
        '1.4.1.	Em caso de perda do Veículo, a CFMOTO fornecerá ao Cliente os dados de localização do Veículo e outros dados úteis sobre o estado do Veículo (como localização da última ativação, estado atual do veículo, etc.) mediante solicitação e se disponível.',
      text19: '1.4.2.	O pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
      text20: '1.5.	Relatórios de problemas pós-venda .',
      text21: '1.5.1.	A CFMOTO recolhe remotamente as notificações de códigos de erro enviadas pelo Veículo em caso de avaria dos seus componentes e fornece as respetivas informações a pedido do Cliente diretamente ao Cliente.',
      text22: '1.5.2.	O pedido deve ser apresentado à CFMOTO pelo Cliente através do distribuidor/parceiro comercial local indicado no Contrato de Venda de Veículos.',
      text23: '2.	Restrições e Exclusões de Serviço',
      text24: '2.1.	Ressalta-se expressamente que alterações estruturais ou outras técnicas do Veículo podem limitar a prestação dos serviços ou mesmo inviabilizá-la, uma vez que os serviços dependem do correto fornecimento dos dados do veículo.',
      text25: '2.2.	Quando tais serviços não puderem ser prestados devido ao desempenho de quaisquer dados de terceiros ou redes de telecomunicações, qualquer responsabilidade da CFMOTO é excluída.',
      text26: '3.	Privacidade',
      text27:
        'A CFMOTO cumprirá os regulamentos de proteção de dados aplicáveis ao processar dados pessoais em conexão com o veículo CFMOTO . Os termos da política de privacidade da C FMOTO estão definidos neste aplicativo CFMOTO RIDE . Como complemento da política de privacidade , este aviso está em conformidade com a política de privacidade . E o Cliente pode consultar a política de privacidade para alguns conteúdos relacionados ao processamento de dados não cobertos por este aviso.',
      text28: '4.	Atendimento ao Cliente',
      text29:
        '4.1.	O cliente pode enviar perguntas, comentários ou preocupações relacionadas à privacidade para CFMOTORIDEAPP@cfmotousa.com ou escrever para: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. O cliente também pode ligar Relacionamento com o cliente CFMOTO em (888) 823-6686. ',
      text30: '5.	R evisões',
      text31: '5.1.	A CFMOTO reserva-se o direito de alterar este aviso a qualquer momento, mas publicaremos as revisões no CFMOTO RIDE App e/ou fornecer aviso antes de fazê-lo, conforme apropriado.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'As novas configurações entrarão em vigor dentro de 1 a 3 minutos após o veículo ser ligado, certifique-se de que o veículo esteja em uma boa posição de sinal',
      setSuccess: 'Definir com sucesso',
      sure: 'Certa',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      cContent: 'As configurações ainda não foram salvas, deseja salvá-las?',
      save: 'Salvar configurações',
      introduce1: 'Perto das instruções de desbloqueio automático',
      introduce2: 'instruções de desligamento automático',
      introduce3: 'Instruções de ativação automática',
      introduce4: 'Luzes atrasadas apagadas',
      content1: {
        msg1: 'Depois que a função é ativada, o celular liga o Bluetooth e o APP continua funcionando. Ao se aproximar do veículo de longe para perto, o veículo pode ser desbloqueado e ligado automaticamente.',
        msg2: 'Se normalmente não estiver desbloqueado e ligado, pressione o botão liga / desliga do veículo para desbloquear e ligar',
        msg3: 'O desbloqueio automático de proximidade só será acionado uma vez antes do bluetooth ser desconectado',
      },
      content2: {
        msg1: 'Após a função ser ligada, o veículo desligará automaticamente após 5 segundos após as três condições do veículo serem desligadas, a velocidade do veículo é 0 e O templo caiu',
        msg2: 'Iniciar o veículo durante o período de desligamento automático, a velocidade do veículo não é 0 ou a têmpora é colocada cancelará o desligamento automático',
      },
      content3: {
        msg1: 'Depois que a função é ligada, quando o veículo é desligado, o celular liga o Bluetooth e o APP continua funcionando ou carrega a chave física. Ao se aproximar do veículo de longe para perto, as luzes do veículo piscarão para receber os convidados',
        msg2: 'Para evitar que gatilhos frequentes causem perda de energia do veículo, após a função de boas-vindas ser acionada duas vezes em 30 segundos, ela não será retomada até 30 minutos depois',
      },
      content4: {
        msg1: 'Depois que a função é ativada, as luzes de farol baixo e distante serão ligadas automaticamente por 10 segundos após o veículo ser desligado',
      },
    },
    feedback: {
      label: {
        type: 'Tipo de feedback (escolha única)',
        content: 'Descrição do problema',
        fileList: 'Por favor carregue uma foto/vídeo',
        fileList2: '(Máximo 4 imagens / 1 vídeo)',
        feedbackCreate: 'Clique para feedback',
        feedbackSupplement: 'Feedback adicional',
        backHome: 'Voltar à página inicial',
        vehicle: 'veículo associado',
        selectVehicle: 'selecione o veículo',
      },
      placeholder: {
        'content.bug': 'Por favor descreva em detalhe a hora da ocorrência, versão APP, modelo de telemóvel, caminho de operação e descrição do problema para ajudar a localizar e resolver rapidamente o problema!',
        'content.suggest': 'Bem-vindo a fazer sugestões valiosas, iremos considerar seriamente as suas ideias',
        'content.vehicle': 'Por favor, descreva quando aconteceu, como aconteceu e o problema',
        'content.other': 'Por favor, descreva quando aconteceu, como aconteceu e o problema',
        'content.supplement': 'Adicione uma descrição do problema',
        vehicle: 'Selecione um veículo',
      },
      rules: {
        'type.required': 'Seleccione un tipo de comentario',
        'content.required': 'Por favor introduza uma descrição do seu problema',
        'fileList.uploading': 'Carregamento, por favor aguarde',
        'fileList.maxSize': 'O ficheiro enviado é demasiado grande',
        'fileList.overType': 'Formato não suportado',
        'fileList.maxCount': 'O número de carregamentos excede o limite',
        'fileList.acceptImageVideo': 'O vídeo não pode ser seleccionado ao seleccionar as imagens',
        'vehicle.required': 'Selecione um veículo',
      },
      message: {
        empty: 'Neste momento não há registos de feedback.~',
        finish: 'tudo aqui',
        loading: 'Carregando',
        uploadFailed: 'O envio falhou',
        tip: 'Para proteger a segurança da sua conta, não submeta aqui informações pessoais sensíveis, tais como senhas de contas, etc.',
        feedbackSuccess: 'Feedback recebido',
        'submit.error': 'Feedback falha',
        'submit.success': 'Feedback recebido',
      },
    },
    guide: {
      label: { giveFeedback: 'Não resolvido, quero dar feedback' },
    },
    help: {
      label: {
        history: 'Pesquisar registros',
        cancel: 'Cancelar',
        yes: 'Sim',
        no: 'Nie',
        unresolved: 'Ainda não consegue resolver? Clique',
        submitFeedback: 'Enviar feedback',
      },
      placeholder: {
        search: 'Pesquisar',
        'content.required': 'Por favor, digite a palavra-chave',
      },
      message: {
        empty: 'Nenhum conteúdo relacionado',
        empty2: 'Sugira a alteração de palavras-chave ou',
        finish: 'tudo aqui',
        historyDelete: 'Excluir todos os registros de pesquisa?',
        isHelpful: 'Ajuda?',
      },
    },
    unbinding: {
      label: {
        vin: 'Nº do veículo',
        realName: 'Nome completo',
        email: 'Endereço de correio eletrónico',
        phone: 'Número de telefone',
        areaCode: 'Código do país',
        identity: 'Identificação',
        drivingLicense: 'Certificado de Registro do Veículo.',
        backHome: 'Voltar à página inicial',
        areaCodeTitle: 'Código de país',
        latterTitle: 'Perceber',
        agree: 'Aprovado',
        disagree: 'Discordar',
        agreeCheckLabel: 'Eu li e concordo com',
        agreeCheckTitle: 'Instruções para solicitar a desvinculação do veículo',
      },
      placeholder: {
        vin: 'Por favor insira o VIN',
        realName: 'Por favor, digite seu nome verdadeiro',
        email: 'Por favor, indique o seu endereço de e-mail',
        phone: 'Por favor, digite seu número de telefone',
        identity: 'Página principal do cartão de identificação, carta de condução ou passaporte que contém informações pessoais de identificação.',
        drivingLicense: 'Página principal do Certificado de Registro do Veículo com nome do proprietário e VIN.',
      },
      rules: {
        'agree.required': 'Ler e concordar',
        'vin.required': 'Por favor insira o VIN',
        'vin.pattern': 'VIN incorreto, por favor, verifique.',
        'realName.required': 'Por favor, digite seu nome verdadeiro',
        'email.required': 'Por favor, indique o seu endereço de e-mail',
        'email.pattern': 'Formato de endereço de e-mail incorreto, por favor, verifique.',
        'phone.required': 'Por favor, digite seu número de telefone',
        'phone.pattern': 'Erro no formato do número de telefone, verifique',
        'fileList.maxCount': 'O número de carregamentos excede o limite',
        'fileList.uploading': 'Carregamento, por favor aguarde',
      },
      message: {
        imgUploadFailed: 'Falha no upload de imagens',
        securityMessage: 'As informações acima são usadas apenas para verificação de identidade, a CFMOTO protege suas informações.',
        resultMessage: 'Verificaremos os materiais de inscrição o mais rápido possível, preste atenção na barra de notificação ou no centro de mensagens do APP a tempo.',
        loading: 'Carregando',
      },
    },
  },
};
